import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Evaluations = ({ moduleId }: { moduleId: string }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [evaluationDetail, setEvaluationDetail] = useState<any>(null);
  const [showAnswers, setShowAnswers] = useState<{ [key: number]: boolean }>({});

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/evaluations/${moduleId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Error HTTP! Estado: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        setEvaluationDetail(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles de la evaluación:", error);
        setIsLoading(false);
      });
  }, [moduleId]);

  const toggleShowAnswers = (index: number) => {
    setShowAnswers((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="w-full flex flex-col gap-4 px-4 sm:px-0">
      {isLoading ? (
        <p className="text-gray-600 text-sm">Cargando preguntas...</p>
      ) : evaluationDetail?.evaluation?.length > 0 ? (
        evaluationDetail.evaluation.map((question: any, index: number) => (
          <div
            key={index}
            className="border border-gray-300 rounded-md p-4 bg-white shadow-sm"
          >
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
              <div>
                <p className="text-sm font-sourceSans font-semibold text-black">
                  {index + 1}. {question.questionText}
                </p>
                {question.imageUrl && (
                  <img
                    src={question.imageUrl}
                    alt={`Imagen pregunta ${index + 1}`}
                    className="w-full mt-2 rounded-md border max-h-48 object-contain"
                  />
                )}
              </div>
              <button
                onClick={() => toggleShowAnswers(index)}
                className="text-sm text-blue-600 underline hover:text-blue-800 self-start sm:self-auto"
              >
                {showAnswers[index] ? "Ocultar opciones" : "Ver opciones"}
              </button>
            </div>
            {showAnswers[index] && (
              <ul className="mt-3 space-y-2 list-disc pl-4">
                {question.options.map((option: any, idx: number) => (
                  <li key={idx} className="text-gray-700 text-sm font-sourceSans">
                    {option.text}
                    {option.imageUrl && (
                      <img
                        src={option.imageUrl}
                        alt={`Opción ${idx + 1}`}
                        className="w-full mt-1 rounded-md border max-h-40 object-contain"
                      />
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))
      ) : (
        <p className="text-gray-600 text-sm">No se encontraron preguntas.</p>
      )}
    </div>
  );
};

export default Evaluations;
